<script>
import { Radar, mixins } from 'vue-chartjs'
// reactiveProp enlaza automáticamente chartData/props con el gráfico
const { reactiveProp } = mixins
export default {
  /*components: {
    RadarChart: {
      extends: Radar,
      props: ['chartData', 'options'],
      mounted() {
        this.renderChart(this.chartData, this.options)
      },
      watch: {
        chartData: {
          handler() {
            if (this.$data._chart) {
              this.$data._chart.destroy()
            }
            this.renderChart(this.chartData, this.options)
          },
          deep: true
        }
      }
    }
  },*/
  name: 'Radar',
  extends: Radar,
  mixins: [reactiveProp],
  props: ['chartData'],
  data() {
    return {
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: false
        },
        scale: {
          ticks: {
            beginAtZero: true,
            min: 0,
            max: 100,
            stepSize: 20,
            maxTicksLimit: 6,
            fontSize: 11,
            fontColor: '#999',
            callback: function(value) {
              return value;
            }
          },
          gridLines: {
            color: 'rgba(0, 0, 0, 0.1)',
            lineWidth: 1
          },
          angleLines: {
            color: 'rgba(0, 0, 0, 0.1)',
            lineWidth: 1
          },
          pointLabels: {
            fontSize: 13,
            fontColor: '#333',
            fontStyle: 'normal',
            display: true
          }
        },
        /*scale: {
          ticks: {
            beginAtZero: true,
            suggestedMin: 0,
            suggestedMax: 100,
            max: 100,
            min: 0,
            stepSize: 20,
            fontSize: 11,
            fixedStepSize: 20,
            fontColor: '#999',
            maxTicksLimit: 6,  // Limita a 6 ticks (0, 20, 40, 60, 80, 100)

          },
          gridLines: {
            color: 'rgba(0, 0, 0, 0.1)',
            lineWidth: 1
          },
          angleLines: {
            color: 'rgba(0, 0, 0, 0.1)',
            lineWidth: 1
          },
          pointLabels: {
            fontSize: 13,
            fontColor: '#333',
            fontStyle: 'normal'
          }
        },*/
        tooltips: {
          enabled: true,
          backgroundColor: 'rgba(0, 0, 0, 0.8)',
          titleFontSize: 13,
          bodyFontSize: 12,
          callbacks: {
            label: function (tooltipItem, data) {
              return data.labels[tooltipItem.index] + ': ' + tooltipItem.yLabel
            }
          }
        }
      }
    }
  },
  mounted () {
    // renderiza al montar; reactiveProp actualizará en cambios posteriores
    this.renderChart(this.chartData, this.chartOptions)
    // Forzar escala después del render
    if (this.$data._chart) {
      this.$data._chart.options.scale.ticks.max = 100
      this.$data._chart.options.scale.ticks.min = 0
      this.$data._chart.update()
    }
  }

}
</script>

